module.exports = __webpack_public_path__ + "img/skyBg.b13ed9c1.jpg";